<template>
  <div class="container">
    <el-row :gutter="10">
        <el-input size="mini" style="width: 100px" v-model="search" placeholder="可通过餐厅, 食堂, 操作人名称快速搜索">search</el-input>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          size="mini"
          style="width: 300px"
          :clearable="false"
          placeholder="选择日期">
         </el-date-picker>
        <el-checkbox size="mini" v-model="onlyRechecked">只看已复核</el-checkbox>
        <el-badge  class="mark" :value="count[1] && count[1].length || 0">
          <el-tag size="mini" type="primary">采集总数</el-tag>
        </el-badge>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="count[2] && count[2].length || 0">
          <el-tag size="mini" type="success">回测总数</el-tag>
        </el-badge>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="count[3] && count[3].length || 0">
          <el-tag size="mini" type="warning">待标注</el-tag>
        </el-badge>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge class="mark" :value="filterList.length || 0">
          <el-tag size="mini" type="success">总计</el-tag>
        </el-badge>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>
          <el-button
            type="primary"
            size="mini"
            @click="changeTrainable"
            :disabled="selectedRows.length === 0"
          >
            {{activeTab ===
            'use' ?
            '设为非训练批次' :
            '设为训练批次'}}
          </el-button>
        </span>
    </el-row>
    <el-button type="text" @click="selectAll" size="mini">全选</el-button>
    <el-button type="text" @click="selectOthers" size="mini" :disabled="selectedRows.length === 0">反选</el-button>
    <el-button
      type="text"
      size="mini"
      class="danger-text"
      @click="cancelSelect"
      :disabled="selectedRows.length === 0"
    >取消</el-button>
    <vvTable :config="tableConfig" :data="filterList" :height="700" :itemHeight="45">
      <template slot-scope="scope" slot="check_box_slot">
        <el-button
          type="danger"
          size="mini"
          @click="unselect(scope.row)"
          v-if="selectedRows.indexOf(scope.row.label_task_uuid) !== -1"
        >取消</el-button>
        <el-button type="text" size="mini" v-else @click="handleSelect(scope.row)">选择</el-button>
      </template>
      <template slot-scope="scope" slot="eventSlot">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="goCheck(scope.row)">复核</el-button>
        </template>
      </template>
      <template slot-scope="scope" slot="source_slot">
        <el-tag type="primary" size="mini" v-if="scope.row.label_source === '1'">采集</el-tag>
        <el-tag type="warning" size="mini" v-if="scope.row.label_source === '2'">回测</el-tag>
        <el-tag type="success" size="mini" v-if="scope.row.label_source === '3'">待标注</el-tag>
        <i calss="el-icon el-icon-ali-fire"></i>
      </template>
      <template slot-scope="scope" slot="end_ts_slot">{{tsToDate(scope.row.end_check_ts)}}</template>
      <template slot-scope="scope" slot="start_ts_slot">{{tsToDate(scope.row.start_check_ts)}}</template>
      <template slot-scope="scope" slot="day_ts_slot">{{tsToDate(scope.row.day_ts)}}</template>
      <template slot-scope="scope" slot="reviewSlot">
        <el-tag type="success" size="mini" v-if="scope.row.who_review">{{scope.row.who_review}}</el-tag>
        <el-tag type="danger" v-else size="mini">未复核</el-tag>
      </template>
      <template slot-scope="scope" slot="eventSlot">
        <el-button type="text" @click="goCheck(scope.row)" size="mini">复核</el-button>
      </template>
    </vvTable>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import moment from 'moment';
import pinyinMatch from 'pinyin-match';

import {apiSetTaskTrainable} from '@/api';
import vvTable from 'vue-virtual-table';
import util from '@/lib/util';

export default {
  name: "cardTable",
  components: {
    vvTable
  },
  props: {
    activeTab: "",
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      onlyRechecked: false,
      allSelected: false,
      tableData: [],
      inverseSelect: false,
      dateRange: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 10),
        new Date()
      ],
      tableConfig: [
        {
          prop: "_action",
          name: "选择",
          actionName: "check_box_slot",
          width: 100
        },
        { prop: "_action", name: "类型", actionName: "source_slot" },
        { prop: "canteen_name", name: "餐厅" },
        { prop: "username", name: "操作人" },
        { prop: "_action", name: "任务时间", actionName: "day_ts_slot" },
        {
          prop: "_action",
          name: "新建任务前复核状态",
          actionName: "reviewSlot",
          filterable: true
        },
        { prop: "_action", name: "操作", actionName: "eventSlot", width: 200 }
      ],
      search: "",
      selectedRows: []
    };
  },
  mounted() {},
  activated() {
    this.selectedRows = [];
    this.selectedRows = this.$_.cloneDeep(this.taskUUIDForTrainList);
  },
  filters: {},
  methods: {
    ...mapMutations(["setTaskUUIDForTrainList"]),
    ...mapActions([]),
    cancelSelect() {
      this.selectedRows = [];
      this.$emit("selectionChange", this.selectedRows);
    },
    selectAll() {
      this.allSelected = !this.allSelected;
      let label_task_uuid_list = this.filterList.map(a => a.label_task_uuid);
      this.selectedRows.push(label_task_uuid_list);
      this.selectedRows = this.$_.uniq(this.$_.flatten(this.selectedRows));
      this.$emit("selectionChange", this.selectedRows);
    },
    selectOthers() {
      let label_task_uuid_list = this.filterList.map(a => a.label_task_uuid);
      let others = this.$_.difference(label_task_uuid_list, this.selectedRows);
      let insections = this.$_.intersection(label_task_uuid_list, this.selectedRows);
      this.$_.pullAll(this.selectedRows, insections);
      this.selectedRows.push(others);
      this.selectedRows = this.$_.uniq(this.$_.flatten(this.selectedRows));
      this.$emit("selectionChange", this.selectedRows);
    },
    handleSelect(row) {
      const { label_task_uuid } = row;
      // console.log(label_task_uuid);
      // let res = this.$_.find(this.list, a => a.label_task_uuid === label_task_uuid);
      // console.log(res);
      if (this.selectedRows.indexOf(label_task_uuid) === -1) {
        this.selectedRows.push(label_task_uuid);
      }
      this.$emit("selectionChange", this.selectedRows);

      // res && this.$set(this.list, 'selected', true);
    },
    unselect(row) {
      const { label_task_uuid } = row;
      // if (this.selectedRows.indexOf(label_task_uuid) === -1) {
      //   this.selectedRows.push(label_task_uuid);
      // }
      let idx = this.selectedRows.indexOf(label_task_uuid);
      idx !== -1 && this.selectedRows.splice(idx, 1);
      this.$emit("selectionChange", this.selectedRows);
    },
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    },
    handleSelectionChange(row) {
      this.selectedRows = row;
    },
    filterReviewer(value, row) {
      console.log(row.who_review);
      return row.who_review === value;
    },
    userSelectTrain() {},
    async changeTrainable() {
      let label_task_uuid_list = this.selectedRows.map(a => a.label_task_uuid);
      try {
        await apiSetTaskTrainable({
          label_task_uuid_list,
          trainable: this.activeTab === "use" ? "-1" : "1"
        });
        this.$emit("refresh");
      } catch (e) {
        console.log(e);
        this.$message.error("设置失败");
      }
    },
    filterHandler(value, row, column) {
      console.log(value, row, column);
      const property = column["property"];
      console.log(property);
      return row[property] === value;
    },
    goCheck(row) {
      // this.$emit('goCheck');
      this.$router.push({
        name: "taskHistoryRecheck",
        params: {
          taskInfo: row,
          checkMode: true
        }
      });
    },
    recheck() {
      this.$emit("recheck");
    }
  },
  computed: {
    ...mapGetters([
      'taskUUIDForTrainList'
    ]),
    dateRangeTs () {
      return [
        util.dateToUnixtimestamp(this.dateRange[0], 0),
        util.dateToUnixtimestamp(this.dateRange[1], 1)
      ];
    },
    filterList() {
      // return this.list;
      let search = this.search;
      let list = this.$_.cloneDeep(this.list);
      if (this.onlyRechecked) {
        list = list.filter(a => a.who_review);
      }
      list = list.filter(a => {
        return (a.day_ts > this.dateRangeTs[0] || a.day_ts === this.dateRangeTs[0]) && (a.day_ts < this.dateRangeTs[1] ||
          a.day_ts === this.dateRangeTs[1]);
      });
      list.sort((a, b) => {
        return -a.end_check_ts + b.end_check_ts;
      });
      // return list;
      return list.filter(a => {
        let res = pinyinMatch.match(
          a.canteen_name + "," + a.eatery_name + "," + a.username,
          search
        );
        return res.length > 0;
      });
    },
    count() {
      return this.$_.groupBy(this.filterList, "label_source");
    }
  },
  watch: {
    selectedRows() {
    }
  }
};
</script>
<style>
</style>
